import React from "react";
import { Box, Stack, Typography, Switch, Divider } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

interface NotificationSettingsProps {
  notify: boolean;
  onNotifyChange: (checked: boolean) => void;
  disabled?: boolean;
}

const NotificationSettings: React.FC<NotificationSettingsProps> = ({
  notify,
  onNotifyChange,
  disabled,
}) => {
  return (
    <Box>
      <Box
        sx={{
          p: 2,
          border: "1px solid #EAECF0",
          borderRadius: "12px",
          boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: 18,
            fontWeight: 600,
            mb: 1,
            lineHeight: "28px",
          }}
        >
          Notification settings
        </Typography>
        <Divider sx={{ borderColor: "#EAECF0" }} />

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box sx={{ mt: 2 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}
            >
              <NotificationsIcon
                sx={{
                  fontSize: 20,
                }}
              />
              <Typography
                sx={{
                  fontSize: 16,
                  fontWeight: 400,
                  lineHeight: "24px",
                }}
              >
                Send initial notification
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontSize: 12,
                lineHeight: "18px",
              }}
            >
              Deadline is required for mandatory assignments
            </Typography>
          </Box>
          <Switch
            checked={notify}
            disabled={disabled}
            onChange={(e) => onNotifyChange(e.target.checked)}
          />
        </Stack>
      </Box>
    </Box>
  );
};

export default NotificationSettings;
